<template>
<div>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>

    <v-row no-gutters class="pa-0" v-if="!raz3">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz3Items"
          v-model="raz3Selected"
          label="Odaberite razinu 3"
          single-line
          item-text="klasusRaz3"
          item-value="Razina3"
          return-object
          persistent-hint
          clearable
          dense
          outlined
          disabled
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-0" v-if="raz3">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz3Items"
          v-model="raz3Selected"
          label="Odaberite razinu 3"
          single-line
          item-text="klasusRaz3"
          item-value="Razina3"
          return-object
          persistent-hint
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>

    <KlasusLevel4 :raz1Selected="raz1Selected" :raz2Selected="raz2Selected" :raz3Selected="raz3Selected"/>
</div>
</template>

<script>


import KlasusService from '@/services/KlasusService'
import KlasusLevel4 from './KlasusLevel4.vue'
export default {
  name: 'klasuslevel3',
  props:['raz1Selected','raz2Selected'],
  data () {
    return {
      msg: '',
      saving: false,
      raz3: false,
      raz3Items: [],
      raz3Selected: {},
      razUpit: {}
    }
  },
  async mounted () {
    await this.findRaz3()
  },
  methods: {
    async findRaz3() {
      let trazi = false

      if (Object.keys(this.raz1Selected).length > 0 && Object.keys(this.raz2Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
        this.razUpit.Razina2 = this.raz2Selected.Razina2
        this.razUpit.onLevel = 3
        trazi = true
      }
      if (trazi) {
        console.log('Trazim na razini 3 ->', this.raz1Selected, this.raz2Selected)
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.raz3Items = res.data.klasusData
            this.raz3 = true
            console.log('this.raz3Items', this.raz3Items)
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Klasus Raz 3 ' + err
        })
      }
    }

  },
  computed: {

  },
  watch: {
    'raz2Selected'() {
      if (this.raz2Selected) {
        this.findRaz3()
      }
      if (!this.raz2Selected) {
        console.log('sad ga nemam razina 3')
        this.raz3 = false
      }
    }
  },
  components: {
    KlasusLevel4
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
